import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FooterComponent} from './footer.component';
import {RouterModule} from '@angular/router';
import {TuiSvgModule} from '@taiga-ui/core/components/svg';
import {TuiButtonModule} from '@taiga-ui/core/components/button';
import {TuiToggleModule} from '@taiga-ui/kit/components/toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TuiLetModule} from '@taiga-ui/cdk';
import {TuiExpandModule} from '@taiga-ui/core';
import {TuiAvatarModule} from '@taiga-ui/kit';
import {CoreModule} from '@core/core.module';
import {ImageVariantModule} from '@tisa-group/core';

@NgModule({
  declarations: [FooterComponent],
  exports: [FooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    TuiSvgModule,
    TuiButtonModule,
    TuiToggleModule,
    FormsModule,
    TuiLetModule,
    TuiExpandModule,
    TuiAvatarModule,
    CoreModule,
    ReactiveFormsModule,
    ImageVariantModule,
  ],
})
export class FooterModule {}
